export default __webpack_public_path__ + "static/media/departmentIcon.295e3b90.svg";